import React, { useState } from 'react';
import { KiteIcon } from '@kite/react-kite';
import { SmartLink } from '../SmartLink/SmartLink';
import { VideoCardTrioCard } from './VideoCardTrioCard';
import './VideoCardTrio.scss';

export interface VideoCardTrioInputs {
    id: string;
    header?: string;
    inline?: boolean;
    cards: VideoCardTrioCard[];
    videoChannelLink?: string;
}

export const VideoCardTrio = ({ inputs }: { inputs: VideoCardTrioInputs }) => {
    if (!inputs) return;

    const [videoIdx, setVideoIdx] = useState(0);
    const cards = inputs.cards.filter((card) => card.image && card.title);

    const handleNextVideoClick = () => {
        let newIdx = videoIdx;
        if (videoIdx + 1 >= cards.length - 1) {
            newIdx = cards.length - 1;
        } else {
            newIdx += 1;
        }
        setVideoIdx(newIdx);
    };

    const handlePrevVideoClick = () => {
        let newIdx = videoIdx;
        if (videoIdx - 1 <= 0) {
            newIdx = 0;
        } else {
            newIdx -= 1;
        }
        setVideoIdx(newIdx);
    };

    return (
        <section className="paragraph__video_card_trio kite-container">
            <hgroup>
                <h2 className="typestack-title-4">{inputs.header}</h2>
                {inputs.videoChannelLink && (
                    <SmartLink url={inputs.videoChannelLink} newWindow>
                        <p>Go To Youtube Channel</p>
                        <KiteIcon icon="ki-arrow-right" size="1.5rem" />
                    </SmartLink>
                )}
            </hgroup>
            <ul>
                {cards.map((card, idx) => {
                    if (idx < 3) {
                        return <VideoCardTrioCard key={card.id} card={card} />;
                    }
                })}
            </ul>
            <ul className="sm-screen">
                {cards.map((card, idx) => {
                    if (idx === videoIdx) {
                        return <VideoCardTrioCard key={card.id} card={card} />;
                    }
                })}
            </ul>
            {/** Only shown on small screens */}
            {cards.length > 1 && (
                <div className="video-idx-controls">
                    <button
                        className="video-idx-controls__button"
                        aria-label="Previous video"
                        onClick={handlePrevVideoClick}
                        disabled={videoIdx === 0}
                    >
                        <KiteIcon icon="ki-chevron-left" size="1.5rem" />
                    </button>
                    <p className="typestack-body-2">
                        {videoIdx + 1} of {cards.length}
                    </p>
                    <button
                        className="video-idx-controls__button"
                        aria-label="Next video"
                        onClick={handleNextVideoClick}
                        disabled={videoIdx === cards.length - 1}
                    >
                        <KiteIcon icon="ki-chevron-right" size="1.5rem" />
                    </button>
                </div>
            )}
        </section>
    );
};
